// extracted by mini-css-extract-plugin
export default {"titleRow":"Tlh1SM0P7Nx4s6ljYLwK"};